import React, { useEffect, useState } from "react";
import { Button, Form, Input, InputNumber, Select } from "antd";
import { DROPDOWNS } from "../../../consts";
import { getCities } from "../../../utils/api";
import MetadataEditorModal from "../MetadataEditorModal";

const EditModalContent = ({
  data,
  setOpen,
  updateCallback,
  countryData,
  cropData,
}) => {
  const [form] = Form.useForm();
  const [currentCountry, setCurrentCountry] = useState(data.country || null);
  const [currentCity, setCurrentCity] = useState(data.city || null);
  const [cityData, setCityData] = useState(null);
  const [isFetchingCities, setIsFetchingCities] = useState(false);

  const [metadataObj, setMetadataObj] = useState(data?.metadata || {});
  const [showMetadataEditor, setShowMetadataEditor] = useState(false);

  // Fetch Cities on Country Change
  useEffect(() => {
    const fn = async () => {
      setIsFetchingCities(true);
      const res = await getCities({ country: currentCountry });
      const cities = res?.data?.data || null;
      setCityData(
        cities?.map((city) => ({ value: city, label: city, key: city })),
      );
      setIsFetchingCities(false);
    };
    if (currentCountry !== null) {
      fn();
    }
  }, [currentCountry]);

  useEffect(() => {
    console.log({ data });
  }, [data]);

  const onFinish = (values) => {
    values.metadata = metadataObj;
    const editData = { ...values, crops: [values.crops] };
    updateCallback(data.id, editData);
    setOpen(false);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="flex justify-center ">
      <Form
        id="editSiteForm"
        className="max-w-[80%]"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          name="name"
          label="Name"
          initialValue={`${data?.name}`}
          rules={[
            {
              required: true,
              message: "name required",
            },
          ]}
        >
          <Input placeholder="Name" />
        </Form.Item>
        <Form.Item
          name="display_name"
          label="Display Name"
          initialValue={`${data?.display_name}`}
          rules={[
            {
              required: true,
              message: "display name required",
            },
          ]}
        >
          <Input placeholder="Display Name" />
        </Form.Item>
        <Form.Item
          name="country"
          label="Country"
          initialValue={data?.country}
          rules={[
            {
              required: true,
              message: "country required",
            },
          ]}
        >
          <Select
            className="min-w-[200px]"
            options={countryData}
            showSearch
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
            onChange={(value) => setCurrentCountry(value)}
          />
        </Form.Item>
        <Form.Item
          name="city"
          label="City"
          initialValue={data?.city}
          rules={[
            {
              required: true,
              message: "city required",
            },
          ]}
        >
          <Select
            className="min-w-[200px]"
            loading={isFetchingCities}
            options={cityData}
            showSearch
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input)
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? "")
                .toLowerCase()
                .localeCompare((optionB?.label ?? "").toLowerCase())
            }
          />
        </Form.Item>
        <div className="flex items-center justify-around">
          <Form.Item
            className="mr-2"
            name="lat"
            label="Latitude"
            initialValue={data?.lat}
            rules={[
              {
                required: true,
                message: "latitude required",
              },
            ]}
          >
            <Input placeholder="Latitude" />
          </Form.Item>
          <Form.Item
            name="long"
            label="Longitude"
            initialValue={data?.long}
            rules={[
              {
                required: true,
                message: "longitude required",
              },
            ]}
          >
            <Input placeholder="Longitude" />
          </Form.Item>
        </div>
        <div className="flex items-center justify-around">
          <Form.Item
            className="mr-2"
            name="size"
            label="Size"
            initialValue={data?.size}
            rules={[
              {
                required: true,
                message: "size required",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            name="growing_environment"
            label="Environment"
            initialValue={data?.growing_environment}
            rules={[
              {
                required: true,
                message: "environment required",
              },
            ]}
          >
            <Select options={DROPDOWNS.GROWING_ENVIRONMENTS} />
          </Form.Item>
        </div>
        <Form.Item
          name="crops"
          label="Crop"
          initialValue={data?.crops[0]?.id}
          rules={[
            {
              required: true,
              message: "environment required",
            },
          ]}
        >
          <Select
            options={cropData?.map((crop) => ({
              label: crop.display_name,
              value: crop.id,
            }))}
          />
        </Form.Item>
        <Form.Item
          name="metadata"
          label="Metadata"
          initialValue={JSON.stringify(data?.metadata)}
          rules={[
            {
              required: true,
              message: "metadata required",
            },
          ]}
        >
          <Button color="primary" onClick={() => setShowMetadataEditor(true)}>
            Edit Metadata
          </Button>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
      <MetadataEditorModal
        name="Site Metadata"
        visible={showMetadataEditor}
        onClose={() => setShowMetadataEditor(false)}
        metadata={metadataObj}
        onUpdateMetadata={(updatedMetadata) => setMetadataObj(updatedMetadata)}
      />
    </div>
  );
};

export default EditModalContent;
